import i18n from "@/app/i18n";
import { NavItem } from "./types";

const getNavData = (): NavItem[] => {
  const t = i18n.t.bind(i18n);
  return [
    // Seller or Buyer
    {
      label: t("outgoing_requests"),
      to: "/seller/deals",
      condition: ({ cabinetType }) => cabinetType === "sellerOrBuyer",
    },
    {
      label: t("incoming_requests"),
      to: "/buyer/incoming-requests",
      condition: ({ cabinetType }) => cabinetType === "sellerOrBuyer",
    },

    // Factor
    {
      label: t("main_page"),
      to: "/factor/main",
      condition: ({ cabinetType }) => cabinetType === "factor",
    },
    {
      label: t("requests_control"),
      to: "/factor/requests",
      condition: ({ cabinetType }) => cabinetType === "factor",
    },
    {
      label: t("limits_control"),
      to: "/factor/limits",
      condition: ({ cabinetType }) => cabinetType === "factor",
    },

    // Landing
    {
      label: t("about_platform_request"),
      to: "#about",
      isLanding: true,
    },
    {
      label: t("how_it_works_request"),
      to: "#how-it-works",
      isLanding: true,
    },
    {
      label: t("partners"),
      to: "#partners",
      isLanding: true,
    },
    {
      label: t("certificates"),
      to: "#certificates",
      isLanding: true,
    },
    {
      label: t("faq_request"),
      to: "#faq",
      isLanding: true,
    },
  ];
};

export default getNavData;
